import { CoreBackendService } from './CoreBackendService'

import { appConfig } from 'Config'

export const coreBackendService = new CoreBackendService({ baseURL: appConfig.backendUrl })
